<template>
  <div class="trial-remind home-top-remind" v-expose.aliyun v-if="isExp || !isUsable">
    <xin-icon xin-type="icon_tips_standard" class="m_r4" />
    {{$xinI18n('您当前处于试用状态，员工信息中证件号和手机号为虚拟号，正式使用后请补充完整！','Home-exp-message')}}
  </div>
</template>

<script lang="ts">
  import { Component, Vue } from 'vue-property-decorator';
  import {namespace} from 'vuex-class';
  const moduleInfra = namespace('moduleInfra');

  @Component({
    components: {

    }
  })
  export default class TrialRemind extends Vue {
    //签约信息
    @moduleInfra.Getter('getIsExp') public isExp!: boolean;
    @moduleInfra.Getter("getIsUsable") isUsable!: boolean;

  }
</script>

<style lang="scss" scoped>
.trial-remind {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  background: #F4FAFF;
  font-size: 12px;
  font-weight: 400;
  color: #3D3D3D;
  .xin-icon{
    font-size: 13px;
    color: #32A7FE;;
  }
}
</style>
